import { createAction } from 'typesafe-actions';

import { CurrentUser } from './types';

export const setCurrentUser = createAction(
  'SET_CURRENT_USER',
  (action) => (currentUser: CurrentUser) => action(currentUser)
);
